// src/components/RegisterSuccess.js
import React, { useContext, useEffect } from 'react';
import './RegisterSuccess.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { Modal, Button } from 'react-bootstrap';
import stripimg from '../assets/Registration/strip.png';
import congratulations from '../assets/Registration/congratulations-icon.png';
import BorderBlack from '../assets/Registration/border-black.png';
import { useNavigate } from 'react-router-dom';
import { BASE_URLS } from '../utils/baseUrls';
import ToastNotification from './Toast/ToastNotification';
import { DataContext } from '../context/DataProvider';
import axiosMain from '../axiosMain';


const RegisterSuccess = ({ showSuccessModal, setShowSuccessModal, setSuccRegister, logInDetails }) => {
  const navigate = useNavigate();
  const { setIsLoggedInTrue, setLoggedUserDetail } = useContext(DataContext);
  const fnLoginAfterRegister = async () => {

    await axiosMain
      .post(BASE_URLS + "/Registration/Login_new", {
        Email: logInDetails?.email,
        Password: logInDetails?.password,
      })

      ?.then((res) => {

        if (res?.data?.ConfirmationStatus === 1) {
          ToastNotification.success(res?.data?.SuccessMessage);
          setLoggedUserDetail(res?.data);
          localStorage.setItem("logDetails", JSON.stringify(res?.data));
          localStorage.setItem("token", res?.data?.Token);
          setIsLoggedInTrue(true);
          navigate("/chat");
          try {

          } catch (error) {
            console.error("Error in onLoginSuccess:", error);
          }
          // }
          // else if (res?.data?.ConfirmationStatus === 3) {
          //   ToastNotification.success(res?.data?.SuccessMessage);
          //   setLoggedUserDetail(res?.data);
          //   localStorage.setItem("logDetails", JSON.stringify(res?.data));
          //   localStorage.setItem("token", res?.data?.Token);

          //   try {
          //   } catch (error) {
          //     console.error("Error in onLoginSuccess:", error);
          //   }
        }
        else {
          ToastNotification.warning(res?.data?.SuccessMessage);
        }
      })
      ?.catch((err) => {
        ToastNotification.error("Login failed !!");
      })
  }
  const goHome = async () => {
    setShowSuccessModal(false);
    setSuccRegister(false);
    // await fnLoginAfterRegister();
    navigate("/");
  };

  useEffect(() => {
    const runLogin = async () => {
      if (showSuccessModal) {
        await fnLoginAfterRegister();
      }
    };
    runLogin();
  }, [showSuccessModal]);

  return (
    <Modal
      size="lg"
      show={showSuccessModal}
      onHide={() => setShowSuccessModal(false)}
      centered
      contentClassName="p-4 text-center bg-success-sign-up"
    >
      <Modal.Header className="border-0">
        <Button
          variant=""
          onClick={() => { setShowSuccessModal(false); goHome(); }}
          className="modal-btn-close ms-auto"
        >
          <i className="fa fa-close"></i>
        </Button>
      </Modal.Header>

      <Modal.Body>
        <img className="strip strip-left" src={stripimg} alt="strip" />
        <img className="strip strip-right" src={stripimg} alt="strip" />

        <h4 className="reg-well-text">Thank You for Registering!</h4>
        <p className="verification-info">
          Please check your inbox for login details and email verification.
        </p>
        <p className="resend-link">
          (Didn't receive it? <a href="#">Resend Email Verification</a>)
        </p>

        <img className="border-black" src={BorderBlack} alt="border" />

        <div className="con-well-text">
          <img
            className="con-sm-icon"
            src={congratulations}
            alt="congrats"
          />
          Congratulations!
        </div>

        <div className="bonus">
          <span className="bonus-amount">500</span>
          <span className="currency-label"> Credit</span>
        </div>

        <p className="amount-credit-short-info">
          has been successfully credited to your TenderGPT wallet.
          <br />
          Start exploring and use your credit now.
        </p>

        <div className="ft-action-button d-flex justify-content-center gap-3 mt-4">
          <a href="#" className="view-sku btn btn-outline-light">
            View SKU
          </a>
          <a onClick={goHome} className="go-to-home btn btn-light">
            Go to Home
          </a>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default RegisterSuccess;
